import { connect } from "react-redux";

import {
  requestLogout,
  requestChangePassword
} from "../../store/authentication/thunks";
import { setFailureMessage } from "../../store/authentication/actions";
import Home from "./Home";
import { State } from "../../store/state";

const mapStateToProps = (state: State) => ({
  user: state.authentication.user,
  failureMessage: state.authentication.failureMessage,
  initiatePasswordChange: state.authentication.initiatePasswordChange
});

const mapDispatchToProps = {
  requestLogout,
  requestChangePassword,
  setFailureMessage
};

const HomeContainer = connect(mapStateToProps, mapDispatchToProps)(Home);

export default HomeContainer;
